import best from "../../Assets/Sertifikat/1.png";
import bestSI from "../../Assets/Sertifikat/2.png";
import ptpn from "../../Assets/Sertifikat/3.png";
import kkn from "../../Assets/Sertifikat/4.png";
import pmm from "../../Assets/Sertifikat/5.png";
import asean from "../../Assets/Sertifikat/6.png";
import telkomsel from "../../Assets/Sertifikat/7.png";
import msib from "../../Assets/Sertifikat/8.png";
import umm from "../../Assets/Sertifikat/9.png";
import camp404 from "../../Assets/Sertifikat/10.png";
import hack4id from "../../Assets/Sertifikat/11.png";
import sql from "../../Assets/Sertifikat/12.png";
import python from "../../Assets/Sertifikat/13.png";
import visual from "../../Assets/Sertifikat/14.png";

const LicenseData = [
  {
    id: 1,
    title: "Best Graduate",
    issuer: "Universitas Muhammadiyah Sumatera Utara",
    image: best,
  },

  {
    id: 2,
    title: "Best Information Systems Graduate",
    issuer: "Faculty of Computer Science and Information Technology",
    image: bestSI,
  },

  {
    id: 3,
    title: "Magang Bersertifikat (MSIB) Batch 7 ",
    issuer: "Kampus Merdeka",
    image: msib,
  },

  {
    id: 4,
    title: "Pertukaran Mahasiswa Merdeka Batch 4",
    issuer: "Kampus Merdeka",
    image: pmm,
  },

  {
    id: 5,
    title: "Software Engineer Internship",
    issuer: "PT Telkomsel Indonesia",
    image: telkomsel,
  },

  {
    id: 6,
    title: "Student Exchange Completion Certificate",
    issuer: "Universitas Muhammadiyah Malang",
    image: umm,
  },

  {
    id: 7,
    title: "ASEAN Data Science Explorers",
    issuer: "ASEAN Foundation & SAP",
    image: asean,
  },

  {
    id: 8,
    title: "IT Support Internship",
    issuer: "PT Perkebunan Nusantara IV Regional II",
    image: ptpn,
  },

  {
    id: 9,
    title: "Best Leader",
    issuer: "Kepala Desa Bengkel, Serdang Bedagai",
    image: kkn,
  },
  {
    id: 10,
    title: "Web Programming Fundamentals",
    issuer: "Camp404",
    image: camp404,
  },

  {
    id: 11,
    title: "Hack4ID",
    issuer: "Ministry of Communication and Digital Affairs (Kominfo)",
    image: hack4id,
  },

  {
    id: 12,
    title: "Structured Query Language (SQL) Fundamentals",
    issuer: "Dicoding",
    image: sql,
  },

  {
    id: 13,
    title: "Python Programming Fundamentals",
    issuer: "Dicoding",
    image: python,
  },

  {
    id: 14,
    title: "Data Visualization Fundamentals",
    issuer: "Dicoding",
    image: visual,
  },
];

export default LicenseData;
